import * as React from "react";

import styles from "./Textarea.module.css";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ className, ...props }, ref) {
    return (
      <textarea
        ref={ref}
        className={
          className ? `${styles.textarea} ${className}` : styles.textarea
        }
        {...props}
      />
    );
  },
);
